/* Dansk katalog for locale-no.js (del 7 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'bg.balanceDiscrepancy': 'Saldoafvigelse',
  'bg.notCorrect': 'Ikke korrekt',
  'bg.reconciliationDone': 'Bankafstemningen er fuldført',
  'bg.reconciliationDoneHelp': 'Kontoudtoget er kontrolleret, bogført og flyttet til arkivet.',
  'bg.bankLines': 'Banklinjer',
  'bg.reconciled': 'Afstemt',
  'bg.backToBank': 'Tilbage til Bank',
  'bg.reopenReconciliation': 'Genåbn afstemningen',
  'bg.bankAccountCaps': 'BANKKONTO',
  'bg.periodCaps': 'PERIODE',
  'bg.balanceAtStart': 'Saldo ved periodens start',
  'bg.balanceAtEnd': 'Saldo ved periodens slutning',
  'bg.balancesMatch': 'Saldiene stemmer.',
  'bg.roundingHelp': 'Dette kan bogføres på afrundingskonto 7770 uden at ændre beløbet fra kontoudtoget.',
  'bg.balancesMatchContinue': 'Saldiene stemmer – fortsæt',
  'bg.suggestionsHeading': 'SuperPlumma har matchet og foreslået bogføring — du bestemmer',
  'bg.noSuggestions': 'Ingen forslag venter på godkendelse.',
  'bg.continueToRest': 'Fortsæt til resten',
  'bg.noPostedDiscrepancies': 'Ingen bogførte poster skaber afvigelser.',
  'bg.checkAndFix': 'Kontrollér og ret posterne, før perioden afsluttes.',
  'bg.allPaymentsHandled': 'Alle betalinger er behandlet.',
  'bg.continueToVouchers': 'Fortsæt til bilag',
  'bg.allPurchasesDocumented': 'Alle køb har den nødvendige dokumentation eller er markeret som uden bilag.',
  'bg.seePurchase': 'Se købet',
  'bg.withoutVoucher': 'Uden bilag',
  'bg.linkSuggested': 'Tilknyt foreslået',
  'bg.pickVoucher': 'Vælg bilag',
  'bg.continueToFinish': 'Fortsæt til afslutning',
  'bg.bankLinesTotal': 'Banklinjer i alt',
  'bg.linkedPosted': 'Tilknyttet/bogført',
  'bg.privateMovements': 'Private bevægelser',
  'bg.reconcileAndArchive': 'Afstem og arkivér',
  'bg.backAndCheck': 'Tilbage og kontrollér',
  'bg.stepModeHelp': 'Trin for trin fører dig gennem én opgave ad gangen. Fuld oversigt viser alt samlet.',
  'acc.sub': 'Din profil og de virksomheder, du har adgang til.',
  'acc.signOutHelp': 'Logger dig ud af Plumme. Du skal logge ind igen med e-mail og adgangskode for at fortsætte.',
  'acc.yourRole': 'Din rolle',
  'acc.yourRoleHelp': 'Rollen styrer, hvad du kan gøre: Ejer har fuld adgang, Administrator styrer driften, Bogholder fører regnskabet, og Læser kan kun se. Rollen kan være forskellig fra virksomhed til virksomhed.',
  'acc.editProfile': 'Redigér profil',
  'acc.myBusinesses': 'Mine virksomheder',
  'acc.myBusinessesHelp': 'De virksomheder, du har adgang til i Plumme. Mærkaten viser din rolle i hver virksomhed. Tryk på en virksomhed for at åbne regnskabet.',
  'acc.personalFinanceHelp': 'Privatøkonomi er en separat klienttype for personlig økonomi og husholdning, adskilt fra virksomhedernes regnskab.',
  'acc.goToPersonalFinance': 'Gå til privatøkonomi',
  'acc.ownPersonalClient': 'Egen privatøkonomi-klient',
  'acc.myEmployers': 'Mine arbejdsgivere',
  'acc.myEmployersHelp': 'Virksomheder, du er ansat i (og ikke nødvendigvis fører regnskab for). Her finder du efterhånden lønsedler, kontrakter og din egen medarbejderside.',
  'acc.employerPortalAccess': 'Virksomheder, du har adgang til medarbejderportalen hos.',
  'acc.changePicture': 'Skift billede',
  'acc.removePicture': 'Fjern billede',
  'acc.photoUploading': 'Uploader …',
  'acc.photoRemoving': 'Fjerner …',
  'acc.photoSaved': 'Profilbilledet er opdateret.',
  'acc.photoRemoved': 'Profilbilledet er fjernet.',
  'acc.photoWrongType': 'Vælg et billede i PNG, JPG eller WebP.',
  'acc.photoEmpty': 'Billedfilen er tom.',
  'acc.photoTooLarge': 'Billedet er for stort. Maks. 2 MB.',
  'acc.photoUploadFailed': 'Profilbilledet kunne ikke uploades.',
  'acc.photoRemoveFailed': 'Profilbilledet kunne ikke fjernes.',
  'acc.photoUnavailable': 'Profilbillede er ikke tilgængeligt lige nu.',
  'acc.fullName': 'Fulde navn',
  'acc.phoneFromLogin': 'Telefon fra login',
  'acc.changePassword': 'Skift adgangskode',
  'acc.changes': 'Ændringer',
  'acc.noChangeDetails': 'Der er ikke gemt ekstra ændringsdetaljer for denne hændelse.',
  'acc.logSub': 'Hvad der er gjort i regnskabet - og af hvem.',
  'acc.logFilterHelp': 'Filtrér loggen efter periode, område (f.eks. Faktura, Løn, Moms) og hvilken bruger der udførte handlingen.',
  'acc.area': 'Område',
  'acc.areaHelp': 'Hvilken del af regnskabet handlingen vedrører - f.eks. Faktura, Køb, Løn eller Moms. En handling kan berøre flere områder.',
  'acc.user': 'Bruger',
  'acc.userHelp': 'Den person, der udførte handlingen, med sin rolle. Sådan ser du, hvem der står bag hver ændring.',
  'acc.sentLinkTo': 'Vi har sendt et link til',
  'bud.annualBudget': 'Årsbudget',
  'bud.suggestion': 'Budgetforslag',
  'bud.createSuggestion': 'Lav forslag',
  'bud.startSimpleQuestions': 'Start med enkle spørgsmål',
  'bud.fillRelevant': 'Udfyld kun det, der er relevant. Månedsbeløb omregnes til årsbudget.',
  'bud.businessDescription': 'Beskrivelse af virksomheden',
  'bud.businessDescriptionPh': 'F.eks. Vognmandsforretning for 2027 med 2 varebiler, 2 ansatte, kontorleje 8 000/md. og flere indtægter om sommeren.',
  'bud.howToBudget': 'Sådan laver du et budget',
  'bud.howToBudgetHelp': 'Vælg metode: Med »Manuelt« indtaster du selv kontiene, med »Forslag« svarer du på nogle enkle spørgsmål og får en kladde, og med »AI-forslag« beskriver du virksomheden med egne ord, så laver Plumme en kladde.',
  'bud.budgetedResult': 'Budgetteret resultat',
  'bud.budgetedResultHelp': 'Det resultat, du har budgetteret for hele året — summen af budgetterede indtægter minus budgetterede omkostninger. Det er målet, du styrer efter.',
  'bud.actualResult': 'Faktisk resultat',
  'bud.actualResultHelp': 'Det faktiske resultat, der er bogført indtil videre i år — reelle indtægter minus reelle omkostninger. Sammenlign med budgettet for at se, om du ligger som planlagt.',
  'bud.postedSoFar': 'bogført indtil nu',
  'bud.varianceToPeriod': 'Afvigelse mod periode',
  'bud.varianceToPeriodHelp': 'Forskellen mellem faktisk og budgetteret resultat indtil nu. Negativ afvigelse betyder, at du ligger under budget, positiv, at du ligger over.',
  'bud.incomeTarget': 'Indtægtsmål',
  'bud.incomeTargetHelp': 'Hvor stor en andel af årets budgetterede indtægter du har nået indtil nu — faktisk faktureret indtægt divideret med budgetteret indtægt.',
  'bud.ofTargetReached': 'af målet nået',
  'bud.viewHelp': 'Skift visning: »Oversigt« viser akkumuleret resultat og største afvigelser, »Analyse« viser indtægt mod omkostning og resultat pr. måned, og »Budget pr. kategori« er der, hvor du indtaster og ændrer beløbene.',
  'bud.accumulatedResult': 'Akkumuleret resultat',
  'bud.accumulatedResultHelp': 'Grafen viser resultatet, der bygges op måned for måned gennem året. Den stiplede linje er budgettet, den fuldt optrukne er faktisk bogført — så ser du, om du følger planen.',
  'bud.budgetAtYearEnd': 'Budget ved årets slutning',
  'bud.accumulated': 'akkumuleret',
  'bud.actualSoFar': 'Faktisk indtil nu',
  'bud.posted': 'bogført',
  'bud.varianceSoFar': 'Afvigelse indtil nu',
  'bud.largestVariance': 'Største afvigelse',
  'bud.largestVarianceHelp': 'Den konto, der afviger mest fra budgettet år til dato. Nyttigt til hurtigt at se, hvor du ligger mest over eller under det, du planlagde.',
  'bud.soFarThisYear': 'år til dato',
  'bud.incomeVsCost': 'Indtægter vs. omkostninger pr. måned',
  'bud.incomeVsCostHelp': 'Søjlerne viser indtægter (grøn) mod omkostninger (orange) for hver måned. Skift mellem faktiske tal, budgetterede tal eller begge. Tryk på en måned for at summere et udvalg.',
  'bud.resultPerMonth': 'Resultat pr. måned',
  'bud.resultPerMonthHelp': 'Viser resultatet (indtægter minus omkostninger) for hver enkelt måned, budget mod faktisk. Søjler over midterlinjen er overskud, under er underskud.',
  'bud.actual': 'Faktisk',
  'bud.actualByCategory': 'Faktisk pr. kategori',
  'bud.actualByCategoryHelp': 'Bogførte indtægter og omkostninger pr. konto, fordelt på måneder. Tallene kommer fra dit regnskab — både bilag, du har registreret i Plumme, og tal fra en import — og opdateres af sig selv.',
  'bud.noActuals': 'Ingen bogførte tal for {year} endnu.',
  'bud.actualOnlyHint': 'Dette er faktiske tal. Indtast et budget under Budget, hvis du vil måle dig mod en plan.',
  'bud.byCategory': 'Budget pr. kategori',
  'bud.addIncome': 'Tilføj indtægt',
  'bud.addIncomeHelp': 'Tilføj en indtægtskategori med et årsbeløb — fx forventet salg. Beløbet fordeles på måneder, som du kan justere.',
  'bud.addCost': 'Tilføj omkostning',
  'bud.addCostHelp': 'Tilføj en omkostningskategori med et årsbeløb — fx husleje, varekøb eller software. Beløbet fordeles på måneder, som du kan justere.',
  'bud.noCategories': 'Ingen budgetkategorier endnu. Tilføj indtægt eller omkostning.',
  'bud.useLastYear': 'Brug sidste år',
  'bud.simpleQuestions': 'Enkle spørgsmål',
  'bud.byCategoryHelp': 'Hver række er en budgetkategori. Beløbene for hver af de 12 måneder er altid synlige og kan redigeres direkte i tabellen med årets total til højre.',
  'bud.total': 'Total',
  'bud.annualTotal': 'Årstotal',
  'bud.annualTotalHelp': 'Ændrer du dette tal direkte, fordeles det nye årsbeløb jævnt over alle 12 måneder.',
  'bud.save': 'Gem',
  'bud.methodManual': 'Manuelt',
  'bud.methodSuggestion': 'Forslag',
  'bud.methodAi': 'AI-forslag',
  'bud.modeBudgeted': 'Budgetteret',
  'bud.modeBoth': 'Begge',
  'bud.forWholeYear': 'for hele {year}',
  'bud.underBudget': 'under budget',
  'bud.overBudget': 'over budget',
  'bud.legendBudgetDashed': '- - Budget',
  'bud.legendBudgetSolid': '— Budget',
  'bud.legendActual': '— Faktisk',
  'bud.noVarianceYet': 'Ingen afvigelser endnu',
  'bud.savedToast': 'Budget gemt',
  'bud.saveFailedToast': 'Kunne ikke gemme budget',
  'bud.aiModalTitle': 'AI-budget for {year}',
  'bud.aiDraftBusy': 'Opretter udkast...',
  'bud.aiDraftCreate': 'Opret udkast med AI',
  'bud.aiDescription': 'Beskriv virksomheden med dine egne ord: medarbejdere, løn, aktiver, faste omkostninger og sæsonvariation. Jo flere detaljer, jo bedre udkast.',
  'bud.aiDraftFailedGeneric': 'Jeg kunne ikke oprette et budgetudkast ud fra beskrivelsen. Tilføj flere detaljer, eller brug Forslag.',
  'bud.aiDraftAppliedToast': 'AI-udkast indsat. Tryk på Gem, når det ser rigtigt ud.',
  'bud.aiDraftFailed': 'AI-budgetudkastet mislykkedes.',
  'bud.suggestionIntro': 'Opret et forslag ud fra sidste års faktiske tal, eller besvar et par enkle spørgsmål for at få et startbudget.',
  'bud.catSales': 'Salg af varer og tjenesteydelser',
  'bud.catPurchases': 'Varekøb og direkte omkostninger',
  'bud.catPremises': 'Lokaler',
  'bud.catSoftware': 'Software og udstyr',
  'bud.catAccounting': 'Regnskab og rådgivning',
  'bud.catTravel': 'Rejser',
  'bud.catMarketing': 'Markedsføring',
  'bud.catCommunication': 'Telefon, porto og kommunikation',
  'bud.otherCosts': 'Andre omkostninger',
  'bud.customCategory': 'Egen kategori',
  'bud.q.expectedIncome.label': 'Hvor meget skal du tjene?',
  'bud.q.expectedIncome.hint': 'Forventet faktureret indtægt for hele året.',
  'bud.q.goodsAnnual.label': 'Varekøb',
  'bud.q.goodsAnnual.hint': 'Varer eller materialer, du køber ind til videresalg.',
  'bud.q.officeMonthly.label': 'Kontor/lokale pr. måned',
  'bud.q.officeMonthly.hint': 'Husleje, kontorplads eller lokale.',
  'bud.q.softwareMonthly.label': 'Software pr. måned',
  'bud.q.softwareMonthly.hint': 'Abonnementer, værktøjer og apps.',
  'bud.q.accountingMonthly.label': 'Regnskab/rådgivning pr. måned',
  'bud.q.accountingMonthly.hint': 'Bogholder, rådgiver eller hjælp.',
  'bud.q.travelAnnual.label': 'Bil/rejser pr. år',
  'bud.q.travelAnnual.hint': 'Kørsel, rejser, hotel eller transport.',
  'bud.q.marketingAnnual.label': 'Markedsføring pr. år',
  'bud.q.marketingAnnual.hint': 'Annoncer, profilering og salgsomkostninger.',
  'bud.q.otherAnnual.hint': 'Indsæt en buffer til det, du ikke ved endnu.',
  'aii.superPlumma': 'SuperPlumma',
  'aii.askSuperPlumma': 'Spørg SuperPlumma',
  'aii.chatWithSuperPlumma': 'Chat med SuperPlumma',
  'aii.chatWithMe': 'Chat med mig',
  'aii.healthScore': 'Økonomisk sundhedsscore',
  'po.title': 'Privatøkonomi',
  'po.backToBusiness': 'Tilbage til virksomheden',
  'po.yourAdvisor': 'Din private rådgiver',
  'po.intro': 'Privatøkonomi er din personlige økonomi — helt adskilt fra virksomhedens regnskab. SuperPlumma analyserer indkomst, forbrug, opsparing, lån, pension og skat for husstanden og giver råd, som en privat økonomisk rådgiver ville gøre. «Beta» betyder, at funktionen stadig er under udvikling.',
  'po.hero.greeting.night': 'Godnat.',
  'po.hero.greeting.morning': 'Godmorgen.',
  'po.hero.greeting.day': 'Hej.',
  'po.hero.greeting.evening': 'Godaften.',
  'po.hero.greetingNamed.night': 'Godnat, {name}.',
  'po.hero.greetingNamed.morning': 'Godmorgen, {name}.',
  'po.hero.greetingNamed.day': 'Hej, {name}.',
  'po.hero.greetingNamed.evening': 'Godaften, {name}.',
  'po.hero.section.idag': 'Dagens råd',
  'po.hero.section.oversikt': 'Økonomisk overblik',
  'po.hero.section.forbruk': 'Forbrug',
  'po.hero.section.familie': 'Familieøkonomi',
  'po.hero.section.fremtid': 'Fremtidsplan',
  'po.hero.section.reports': 'Rapporter',
  'po.hero.section.assets': 'Aktiver',
  'po.hero.section.gjeld': 'Gæld',
  'po.hero.section.import': 'Datagrundlag',
  'po.hero.advice.idag': 'Jeg holder øje med din økonomi og fremhæver de vigtigste opgaver og muligheder lige nu.',
  'po.hero.advice.oversikt': 'Se, hvad der trækker den økonomiske sundhed op og ned. Start med det område, der kræver mest opfølgning.',
  'po.hero.advice.forbruk': 'Kig efter kategorier, der er steget, og vælg ét realistisk tiltag, der giver mere luft uden at gøre hverdagen for stram.',
  'po.hero.advice.familie': 'Afklar, hvad der er fælles, hvem der betaler hvad, og hvilke mål husstanden skal prioritere sammen.',
  'po.hero.advice.fremtid': 'Gør målene konkrete med beløb og dato. Så bliver det lettere at se, hvad du bør spare op hver måned.',
  'po.hero.advice.reports': 'Brug rapporterne til at forstå udviklingen over tid, ikke kun ét enkelt højt eller lavt månedsbeløb.',
  'po.hero.advice.assets': 'Kontrollér, at værdier og kontosaldi er opdaterede, før du vurderer nettoformue og langsigtede valg.',
  'po.hero.advice.gjeld': 'Prioritér først en sikker buffer, og overvej derefter ekstra afdrag på gælden med den højeste effektive rente.',
  'po.hero.advice.import': 'Gode råd starter med gode data. Knyt kontoudtogene til den rigtige konto, og ryd op i manglende perioder.',
  'po.pickPerson': 'Vælg person',
  'po.sections': 'Sektioner',
  'po.sectionsHelp': 'Skift mellem områderne: I dag (dagens indsigter), Overblik (sundhedsscore og nøgletal), Forbrug (hvor pengene går hen), Familie, Fremtid (prognose og «hvad sker der, hvis»), Rapporter, Aktiver, Gæld, Skat og Import.',
  'po.outOf100': 'af 100',
  'po.todaysFocus': 'Dagens fokus',
  'po.todaysTasks': 'Dagens opgaver',
  'po.mostImportantToday': 'Vigtigst i dag',
  'po.markDone': 'Marker som fuldført',
  'po.undo': 'Fortryd',
  'po.healthHeading': 'Din samlede økonomiske sundhed — og hvad der påvirker den',
  'po.healthHelp': 'Tallet i ringen (0–100) er en samlet vurdering af din økonomi — jo højere, jo sundere. Kategorierne nedenfor viser, hvad der trækker op og ned: grøn er godt, gul betyder hold øje, og rød kræver opfølgning.',
  'po.noHistory': 'Ingen historik at sammenligne med endnu',
  'po.whatAffectsScore': 'Hvad påvirker scoren mest',
  'po.noDrivers': 'Ingen drivere beregnet endnu',
  'po.noDriversHelp': 'Når der er nok importerede transaktioner, viser jeg, hvad der trækker scoren op og ned.',
  'po.last30Days': 'Seneste registrerede måned',
  'po.last30DaysSub': 'Sammenlignet med foregående kalendermåned',
  'po.financialOverview': 'Økonomisk oversigt',
  'po.financialOverviewSub': 'Et øjebliksbillede af husstandens økonomi',
  'po.recommendations': 'SuperPlummas anbefalinger',
  'po.recommendationsSub': 'De greb, der betyder mest for din økonomi lige nu',
  'po.askMe': 'Spørg mig',
  'po.yourHealthScoreIs': 'Din sundhedsscore er',
  'po.adjustBudget': 'Juster budget',
  'po.budgetTotal': 'Samlet budget:',
  'po.saveBudget': 'Gem budget',
  'po.monthlyLimitPerCategory': 'Månedlig grænse pr. kategori',
  'po.noCategoriesImported': 'Ingen forbrugskategorier importeret endnu. Tilføj egne kategorier nedenfor.',
  'po.ownCategories': 'Egne kategorier',
  'po.pickColour': 'Vælg farve',
  'po.categoryName': 'Navn på kategori',
  'po.removeCategory': 'Fjern kategori',
  'po.addCategory': 'Tilføj kategori',
  'po.budgetVsSpending': 'Budget mod forbrug',
  'po.budgetVsSpendingSub': 'Månedlig grænse mod forbruget i den valgte periode',
  'po.budgetVsSpendingHelp': 'Månedligt budget mod faktisk forbrug pr. kategori. Tryk på «Juster budget» for at sætte grænserne eller oprette egne kategorier. Statuslinjen fyldes efter, hvor meget af budgettet du har brugt — grøn er inden for, gul nærmer sig grænsen, og rød betyder, at kategorien er overskredet. Vælger du årsoversigt, ganges den månedlige grænse med antallet af måneder med importerede data. Budgetterne gemmes for det valgte år.',
  'po.whereMoneyGoes': 'Hvor går pengene hen?',
  'po.whereMoneyGoesSub': 'Tryk på en kategori for at se transaktionerne bag og flytte dem til det rigtige sted',
  'po.whereMoneyGoesHelp': 'Lagkagediagrammet og listen viser forbruget fordelt på kategorier for den valgte periode. Skift periode med knappen øverst — måneder uden importerede transaktioner er grå. Tryk på en kategori for at fremhæve den. Procenten til højre er ændringen i forhold til forrige måned — grøn ned betyder mindre, rød op betyder mere.',
  'po.selectPeriod': 'Vælg periode',
  'po.yearOverview': 'Årsoversigt',
  'po.yearly': 'Årlig',
  'po.month.1': 'Januar',
  'po.month.2': 'Februar',
  'po.month.3': 'Marts',
  'po.month.4': 'April',
  'po.month.5': 'Maj',
  'po.month.6': 'Juni',
  'po.month.7': 'Juli',
  'po.month.8': 'August',
  'po.month.9': 'September',
  'po.month.10': 'Oktober',
  'po.month.11': 'November',
  'po.month.12': 'December',
  'po.largestCategoryIs': 'Største omkostningskategori er',
  'po.recurringCharges': 'Faste træk at overveje',
  'po.recurringChargesSub': 'Tilbagevendende abonnementstræk, som kan være værd at kontrollere',
  'po.opportunity': 'Mulighed',
  'po.estimatedAnnualCost': 'Beregnet årlig omkostning',
  'po.saveAccount': 'Gem konto',
  'po.allAccounts': 'Alle konti',
  'po.uploadedStatements': 'Uploadede kontoudtog',
  'po.yourAccounts': 'Dine konti',
  'po.yourAccountsSub': 'Registrer og sorter dine konti efter type — importerede kontoudtog knyttes til den rigtige konto',
  'po.totalBalance': 'Samlet indestående',
  'po.creditDebt': 'Kreditgæld',
  'po.accounts': 'Konti',
  'po.analysis': 'SuperPlummas analyse',
  'po.analysisSub': 'Hvordan forbruget i kategorien fordeler sig — og hvad du kan gøre',
  'po.whoIsBehind': 'Hvem står bag',
  'po.noTransactionsToAnalyse': 'Ingen transaktioner at analysere endnu.',
  'po.unusualPurchases': 'Usædvanlige køb',
  'po.noUnusualPurchases': 'Ingen køb skiller sig ud i denne periode.',
  'po.searchTransactions': 'Søg i transaktioner …',
  'po.clearSearch': 'Ryd søgning',
  'po.sort': 'Sorter',
  'po.linkStatementToAccount': 'Kobl kontoudtog til konto',
  'po.linkToAccount': 'Kobl til konto',
  'po.newAccount': 'Ny konto',
  'po.accountNamePh': 'F.eks. DNB lønkonto',
  'po.accountNumberPh': 'F.eks. 1234.56.78901',
  'po.currentAccount': 'Lønkonto',
  'po.creditCard': 'Kreditkort',
  'po.me': 'jeg',
  'po.importTitle': 'Importer økonomiske data',
  'po.importSub': 'Upload kontoudtog — SuperPlumma læser og kategoriserer automatisk',
  'po.pickStatement': 'Vælg kontoudtog fra banken',
  'po.pickStatementHelp': 'Upload kontoudtog fra banken. XLSX og CSV læses direkte, PDF læses så godt som muligt fra teksten. SuperPlumma kategoriserer transaktionerne automatisk.',
  'po.pdf': 'PDF',
  'po.noStatementsUploaded': 'Der er ikke uploadet nogen kontoudtog endnu.',
  'po.deleteStatement': 'Slet kontoudtog',
  'po.sharedCosts': 'Bidrag til fælles udgifter',
  'po.sharedCostsSub': 'Hvem betaler hvad af de fælles udgifter — og hvordan det står i forhold til indkomstandelen',
  'po.sharedCostsHelp': 'Søjlen viser, hvor stor en andel af husstandens fælles udgifter hver af jer dækker. Til højre står andelen af den samlede indkomst. Er de to lige store, er fordelingen proportional med indkomsten. Tallene kommer fra det, hver af jer har indtastet på sin egen profil.',
  'po.splitIsEven': 'Fordelingen er jævn. I deler',
  'po.togetherYouCan': 'Sammen kan I',
  'po.togetherYouCanSub': 'Små greb, I kan tage som et hold — beregnet ud fra husstandens egne tal',
  'po.togetherHelp': 'Forslagene er beregnet ud fra den samlede indkomst og de fælles udgifter, I har indtastet. De er ment som fælles mål, ikke krav til enkeltpersoner.',
  'po.sharedSteps': 'Fælles greb',
  'po.magnitude': 'Størrelsesorden',
  'po.youPartnerPh': 'Dig, partner …',
  'po.monthlyNetIncome': 'Månedlig nettoindkomst',
  'po.sharedCostShare': 'Andel af fælles udgifter pr. måned',
  'po.familyFinances': 'Familieøkonomi',
  'po.addPerson': 'Tilføj person',
  'po.noHouseholdMembers': 'Der er ikke registreret nogen husstandsmedlemmer endnu.',
  'po.householdHasRegistered': 'Husstanden har registreret',
  'po.todaysPlan': 'Dagens plan',
  'po.savePlan': 'Gem plan',
  'po.monthlySaving': 'Månedlig opsparing (kr)',
  'po.monthlyExtraDebt': 'Månedligt ekstra afdrag på gæld (kr)',
  'po.targetNetWealth': 'Ønsket nettoformue (kr)',
  'po.expectedReturn': 'Forventet årligt afkast (%)',
  'po.yourAgeToday': 'Din alder i dag (år)',
  'po.desiredRetirementAge': 'Ønsket pensionsalder (år)',
  'po.pickEvent': 'Vælg en begivenhed',
  'po.eventNamePh': 'F.eks. Barn nummer to',
  'po.starts': 'Starter',
  'po.oneOffCost': 'Engangsomkostning (kr)',
  'po.monthlyEffect': 'Månedlig effekt (kr)',
  'po.durationMonths': 'Varighed (måneder)',
  'po.goalName': 'Navn på målet',
  'po.goalNamePh': 'F.eks. Buffer',
  'po.shortDescription': 'Kort beskrivelse',
  'po.whatSavingFor': 'Hvad sparer du op til?',
  'po.targetAmount': 'Målbeløb (kr)',
  'po.savedSoFar': 'Sparet indtil videre (kr)',
  'po.icon': 'Ikon',
  'po.colour': 'Farve',
  'po.debtFree': 'Gældfri',
  'po.saveLoan': 'Gem lån',
  'po.loanType': 'Lånetype',
  'po.spendingCategory': 'Kategori i Forbrug',
  'po.categoryPh': 'F.eks. Bolig',
  'po.debtOverview': 'Gældsoversigt',
  'po.debtOverviewSub': 'Alle dine lån samlet — restgæld, renter og afdragstempo',
  'po.debtOverviewHelp': 'Nøgletallene for al din gæld: samlet restgæld, hvad du afdrager pr. måned, renteudgifter pr. år, gennemsnitsrente og hvor lang tid der går, til du er gældfri.',
  'po.totalDebt': 'Samlet gæld',
  'po.repaymentPerMonth': 'Afdrag pr. måned',
  'po.interestPerYear': 'Renter pr. år',
  'po.averageRate': 'Gennemsnitsrente',
  'po.debtFreeIn': 'Gældfri om',
  'po.loanCount': 'Antal lån',
  'po.yourLoans': 'Dine lån',
  'po.yourLoansSub': 'Tryk på et lån for at se afdragsplan og simulere ændringer',
  'po.addLoan': 'Tilføj lån',
  'po.noLoans': 'Ingen lån tilføjet endnu. Tryk på »Tilføj lån« for at komme i gang.',
  'po.whichLoanFirst': 'Hvilke lån bør du betale ned først?',
  'po.whichLoanFirstSub': 'Rangeret efter rente — det dyreste lån først giver mest igen for hver ekstra krone',
  'po.iRecommend': 'Jeg anbefaler',
  'po.snowballWithRate': 'rentemetoden (lavinemetoden)',
  'po.repaymentSimSub': 'Se, hvordan restgælden falder, og simulér, hvad der sker, hvis du betaler mere eller mindre pr. måned',
  'po.myRecommendation': 'Min anbefaling',
  'po.withChange': 'Med ændring',
  'po.extraRepaymentPerMonth': 'Ekstra afdrag pr. måned',
  'po.dragToPayMore': 'Træk for at betale mere (hurtigere gældfri) eller mindre (længere løbetid)',
  'po.standard': 'Standard',
  'po.savedInInterest': 'Sparet i renter',
  'po.overWholeTerm': 'over hele løbetiden',
  'po.netWealthEffect': 'Effekt på nettoformue',
  'po.becomesYours': 'bliver din, ikke bankens',
  'po.interestPostedAs': 'Renter og afdrag på dette lån bogføres som',
  'po.debtJourney': 'Din gældsrejse',
  'po.debtJourneySub': 'De vigtigste milepæle på vejen mod at blive helt gældfri',
  'po.yourFinancialFuture': 'Din økonomiske fremtid',
  'po.yourFinancialFutureSub': 'Hvor pengene fører dig hen — og hvordan dine valg former vejen dertil',
  'po.showingScenario': 'Viser scenarie:',
  'po.reset': 'Nulstil',
  'po.desiredNetWealth': 'Ønsket nettoformue',
  'po.lastsUntilYouAre': 'rækker, til du er',
  'po.lasts': 'rækker',
  'po.forLife': 'livet ud',
  'po.plummaReadsChart': 'SuperPlumma læser grafen',
  'po.whatIf': 'Hvad sker der, hvis?',
  'po.whatIfSub': 'Tag udgangspunkt i Dagens plan, vælg en beslutning, og justér forudsætningerne — så opdateres grafen, målene, datoerne og pensionen samtidig',
});
